// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let NoteListView
require("./styles/note-list.css")

export default NoteListView = (function () {
  NoteListView = class NoteListView extends (
    require("lib/static-shim").default(
      require("lib/core/composite-view").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-list.html")
      this.prototype.className = "note-list-view"

      this.prototype.childView = require("./note-list-item").default
      this.prototype.childViewContainer = ".note-list-item-container"

      this.prototype.behaviors = {
        Bind: {
          init() {
            // Bindings for the paginate behavior
            return (this.state = new Backbone.Model({
              next_count: 0,
              previous_count: 0
            }))
          },
          serializeBindData() {
            return { state: this.state }
          },
          getBindEl() {
            return this.$(".paginate")
          }
        }, // Avoid overriding the bind on the item view

        PaginatedCollection: {}
      }

      this.prototype.childEvents = {
        "show:note:form"(childView, note) {
          return this.triggerMethod("show:note:form", note)
        }
      }
    }

    onShow() {
      return this.transitionChildViews()
    }

    transitionChildViews() {
      if (this._inTransition) {
        return
      }
      this._inTransition = true
      $.Velocity.animate(
        this.$(".note-list-item-view"),
        "transition.slideRightIn",
        { stagger: 80, duration: 350 }
      )
      return _.delay(() => {
        return (this._inTransition = false)
      }, 350)
    }
  }
  NoteListView.initClass()
  return NoteListView
})()
